const CompetitionStatus = {
  active: "ACTIVE",
  archived: "ARCHIVED",
};

export default CompetitionStatus;
